import { AmaService } from '../ama.service';
import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import {Router} from  '@angular/router';

@Component({
  selector: 'app-ask-request-preview',
  templateUrl: './ask-request-preview.component.html',
  styleUrls: ['./ask-request-preview.component.css']
})
export class AskRequestPreviewComponent implements OnInit {

  Index:boolean = false;
  // QuestionInputData:any = {
  //  "Question": "What is Capital Of India",
  //    "Options": {
  //      "options1": "Delhi",
  //      "options2": "Ballabgarh",
  //      "options3": "Faridabad",
  //      "options4": "Noida"
  //    },
  //    "Gender": "Male",
  //    "Select": "Multiple Select",
  //    "NCCS": [
  //      "NCCS A 70%",
  //      "NCCS B 30%"
  //    ],
  //    "City": [
  //    "Delhi NCR",
  //     "Mumbai",
  //     "Bengaluru",
  //     "Ahmedabad"
  //   ],
  //   "Age_Group": [
  //     "18-24",
  //     "24-30"
  //    ]
  // };

  QuestionInputData:any = {};
  
  QuestionInputDataApi:any;
  postQuestionResponse:any;

  constructor(public amaService:AmaService,private location:Location,private route:Router) { 
    this.QuestionInputData = this.amaService.QuestionInputData;
    // console.log(" newQuestion ",this.QuestionInputData)
  }
  
  ngOnInit(){
    this.QuestionInputDataApi=this.amaService.inputQuestionJson;
  }
  ngOnDestroy(){
    this.amaService.currentQuestionId = null;
    this.amaService.QuestionInputData = {};
  }

  onSubmit(){
    // let inputs=this.QuestionInputData;
    // console.log(inputs);

    // let option=Object.values(inputs.Options);
    // let data={
    //   question:[{Q:inputs.Question,T:inputs.Select,C:option}],
    //   audience:{age:inputs.Age_Group,gender:inputs.Gender,city:inputs.City}
    // };
    //   console.log(data);
    var question_id = 310;

    this.amaService.saveFinalQuestionsdata(this.amaService.currentQuestionId).subscribe((result)=>{
      console.log("result of saveFinalQuestionsdata::",result);
      this.postQuestionResponse=result;
      this.Index = true;
    },(err)=>{
      console.log(err);
    });

  }
  gotoBackPage = () =>
  {
    if(!this.postQuestionResponse)
    {
      this.location.back();
    }
  }
  ConvertArray = () =>
  {
  var arr = [];
  arr = Object.values(this.QuestionInputData.Options);
  return arr;
  }

}
